(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Galerie-ko-stop"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const control = event.target.closest('.ko-stop-projects__arrow');
    if (!control) return;
    const rail = document.getElementById(control.getAttribute('aria-controls'));
    if (!rail) return;
    const card = rail.querySelector('.ko-stop-projects__card');
    if (!card) return;
    const gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
    const direction = Number(control.dataset.projectDirection);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    rail.scrollBy({
      left: direction * (card.getBoundingClientRect().width + gap),
      behavior: reducedMotion ? 'instant' : 'smooth'
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ko-amazon-review-link"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      scope.querySelectorAll('[data-ko-amazon-review-link]').forEach((section) => {
        if (section.dataset.koAmazonInitialized === 'true') return;

        const mapNode = section.querySelector('[data-ko-amazon-variant-map]');
        const link = section.querySelector('[data-ko-amazon-url]');
        if (!mapNode || !link) return;

        let variantLinks = {};
        try {
          variantLinks = JSON.parse(mapNode.textContent);
        } catch (error) {
          return;
        }

        const update = (variantId) => {
          const url = variantLinks[String(variantId)] || '';
          section.hidden = url === '';
          if (url !== '') link.href = url;
        };

        section.dataset.koAmazonInitialized = 'true';
        update(section.dataset.currentVariantId);

        document.addEventListener('variant:change', (event) => {
          const variantId = event.detail?.variant?.id || event.detail?.variantId;
          if (variantId) update(variantId);
        });

        document.addEventListener('change', () => {
          window.setTimeout(() => {
            const urlVariant = new URL(window.location.href).searchParams.get('variant');
            if (urlVariant) update(urlVariant);
          }, 0);
        });

        window.addEventListener('popstate', () => {
          const urlVariant = new URL(window.location.href).searchParams.get('variant');
          if (urlVariant) update(urlVariant);
        });
      });
    };

    initialize();
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ko-stop-b2b-download-library"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var libraries = document.querySelectorAll('[data-download-library]:not([data-library-ready])');

    libraries.forEach(function(root) {
      root.setAttribute('data-library-ready', 'true');

      var search = root.querySelector('[data-library-search]');
      var category = root.querySelector('[data-library-category]');
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-library-card]'));
      var count = root.querySelector('[data-result-count]');
      var empty = root.querySelector('[data-library-empty]');

      function normalize(value) {
        return (value || '').toLocaleLowerCase('de-DE').trim();
      }

      function updateResults() {
        var term = normalize(search ? search.value : '');
        var selectedCategory = category ? category.value : 'all';
        var visible = 0;

        cards.forEach(function(card) {
          var matchesTerm = !term || normalize(card.getAttribute('data-search')).indexOf(term) !== -1;
          var matchesCategory = selectedCategory === 'all' || card.getAttribute('data-category') === selectedCategory;
          var show = matchesTerm && matchesCategory;

          card.hidden = !show;
          if (show) visible += 1;
        });

        if (count) count.textContent = count.getAttribute('data-count-prefix') + ': ' + visible;
        if (empty) empty.hidden = visible !== 0;
      }

      if (search) search.addEventListener('input', updateResults);
      if (category) category.addEventListener('change', updateResults);

      root.addEventListener('click', function(event) {
        var link = event.target.closest('[data-b2b-download]');
        if (!link) return;

        try {
          var privacy = window.Shopify && window.Shopify.customerPrivacy;
          if (privacy && typeof privacy.analyticsProcessingAllowed === 'function' && !privacy.analyticsProcessingAllowed()) return;

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'b2b_file_download_click',
            file_kind: link.getAttribute('data-file-kind') || '',
            file_language: link.getAttribute('data-file-language') || '',
            product_name: link.getAttribute('data-product') || '',
            file_url: link.getAttribute('href') || '',
            content_group: 'b2b_download_library'
          });
        } catch (error) {}
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ko-stop-b2b-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  var roots = document.querySelectorAll('[data-b2b-root]');

  function analyticsAllowed() {
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy) return false;
      if (typeof privacy.analyticsProcessingAllowed === 'function') return !!privacy.analyticsProcessingAllowed();
      if (typeof privacy.currentVisitorConsent === 'function') {
        var consent = privacy.currentVisitorConsent();
        return !!consent && consent.analytics === 'yes';
      }
      return false;
    } catch (error) {
      return false;
    }
  }

  function track(eventName, params) {
    try {
      if (!analyticsAllowed()) return;
      window.dataLayer = window.dataLayer || [];
      var gtag = function () { window.dataLayer.push(arguments); };

      if (!window.__koStopB2BGa4Ready) {
        window.__koStopB2BGa4Ready = true;
        var script = document.createElement('script');
        script.async = true;
        script.src = 'https://www.googletagmanager.com/gtag/js?id=G-HW52E7PKCE';
        document.head.appendChild(script);
        gtag('js', new Date());
        gtag('config', 'G-HW52E7PKCE', { send_page_view: false });
      }

      var payload = params || {};
      payload.send_to = 'G-HW52E7PKCE';
      payload.transport_type = 'beacon';
      gtag('event', eventName, payload);
    } catch (error) {
      return;
    }
  }

  for (var i = 0; i < roots.length; i += 1) {
    var root = roots[i];
    if (root.getAttribute('data-b2b-analytics-ready') === 'true') continue;
    root.setAttribute('data-b2b-analytics-ready', 'true');

    root.addEventListener('click', function (event) {
      var link = event.target.closest('a[href]');
      if (!link || !this.contains(link)) return;
      var area = link.closest('[data-b2b-area]');
      track('b2b_cta_click', {
        cta_text: (link.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 100),
        cta_target: link.getAttribute('href') || '',
        cta_location: link.getAttribute('data-cta-location') || (area ? area.getAttribute('data-b2b-area') : 'b2b_hub'),
        content_group: 'b2b_hub'
      });
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ko-stop-cinematic-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ks-hero-effects')) {
    customElements.define('ks-hero-effects', class extends HTMLElement {
      connectedCallback() {
        this.setupFrame = requestAnimationFrame(() => this.initializeEffects());
      }

      initializeEffects() {
        if (!this.hasAttribute('data-ks-light-effect')) return;
        this.effectMedia = this.querySelector('.ks-hero__media');
        const image = this.querySelector('.ks-hero__image');
        if (!this.effectMedia || !image) return;
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.pointerQuery = window.matchMedia('(min-width: 761px) and (hover: hover) and (pointer: fine)');
        this.motionQuery.addEventListener('change', () => {
          this.resetPointer();
          if (this.motionQuery.matches) this.removeAttribute('data-ks-reveal');
        }, { signal });
        this.pointerQuery.addEventListener('change', () => this.resetPointer(), { signal });
        this.addEventListener('pointermove', event => this.moveLight(event), { passive: true, signal });
        this.addEventListener('pointerleave', () => this.resetPointer(), { signal });
        window.addEventListener('blur', () => this.resetPointer(), { signal });
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) this.resetPointer();
        }, { signal });
        const reveal = () => {
          if (this.motionQuery.matches || this.introPlayed || !this.isConnected) return;
          this.introObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting) || this.motionQuery.matches) return;
            this.setAttribute('data-ks-reveal', '');
            this.introPlayed = true;
            this.introObserver.disconnect();
          }, { threshold: .2 });
          this.introObserver.observe(this.effectMedia);
        };
        if (image.complete && image.naturalWidth) reveal();
        else image.addEventListener('load', reveal, { once: true, signal });
      }

      moveLight(event) {
        if (event.pointerType !== 'mouse' || this.motionQuery.matches || !this.pointerQuery.matches) return;
        this.pointerPosition = { x: event.clientX, y: event.clientY };
        if (this.lightFrame) return;
        this.lightFrame = requestAnimationFrame(() => {
          this.lightFrame = null;
          const rect = this.effectMedia.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          const x = Math.max(0, Math.min(1, (this.pointerPosition.x - rect.left) / rect.width));
          const y = Math.max(0, Math.min(1, (this.pointerPosition.y - rect.top) / rect.height));
          this.style.setProperty('--ks-light-x', `${(x * 100).toFixed(2)}%`);
          this.style.setProperty('--ks-light-y', `${(y * 100).toFixed(2)}%`);
          this.style.setProperty('--ks-drift-x', `${((x - .5) * -14).toFixed(2)}px`);
          this.style.setProperty('--ks-drift-y', `${((y - .5) * -10).toFixed(2)}px`);
          this.setAttribute('data-ks-pointer', '');
        });
      }

      resetPointer() {
        cancelAnimationFrame(this.lightFrame);
        this.lightFrame = null;
        this.removeAttribute('data-ks-pointer');
        ['--ks-drift-x', '--ks-drift-y'].forEach(property => this.style.removeProperty(property));
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.setupFrame);
        this.resetPointer();
        this.introObserver?.disconnect();
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ko-stop-personal-mug"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ks-mug]').forEach((root) => {
    if (root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';

    const fileInputs = {
      primary: root.querySelector('[data-file-input="primary"]'),
      secondary: root.querySelector('[data-file-input="secondary"]')
    };
    const fileNames = {
      primary: root.querySelector('[data-file-name="primary"]'),
      secondary: root.querySelector('[data-file-name="secondary"]')
    };
    const uploadActions = {
      primary: root.querySelector('[data-upload-action="primary"]'),
      secondary: root.querySelector('[data-upload-action="secondary"]')
    };
    const qualityChecks = {
      primary: root.querySelector('[data-quality-check="primary"]'),
      secondary: root.querySelector('[data-quality-check="secondary"]')
    };
    const textInput = root.querySelector('[data-text-input]');
    const fontSelect = root.querySelector('[data-font-select]');
    const textSizeInput = root.querySelector('[data-text-size]');
    const textSizeOutput = root.querySelector('[data-text-size-output]');
    const stage = root.querySelector('[data-preview-stage]');
    const canvas = root.querySelector('[data-mug-canvas]');
    const context = canvas.getContext('2d');
    const editorTools = root.querySelector('[data-editor-tools]');
    const artSizeOutput = root.querySelector('[data-art-size]');
    const layoutSizeInput = root.querySelector('[data-layout-size]');
    const layoutPositionInput = root.querySelector('[data-layout-position]');
    const positionSelect = root.querySelector('[data-position-select]');
    const positionField = root.querySelector('[data-position-field]');
    const wrapNote = root.querySelector('[data-wrap-note]');
    const secondaryUpload = root.querySelector('[data-secondary-upload]');
    const secondaryDropzone = root.querySelector('[data-dropzone="secondary"]');
    const repeatArtwork = root.querySelector('[data-repeat-artwork]');
    const uploadGuidance = root.querySelector('[data-upload-guidance]');
    const modeTitle = root.querySelector('[data-mode-title]');
    const modeDetail = root.querySelector('[data-mode-detail]');
    const modePixels = root.querySelector('[data-mode-pixels]');
    const viewStatus = root.querySelector('[data-view-status]');
    const resetButton = root.querySelector('[data-preview-reset]');
    const form = root.querySelector('form');
    const status = root.querySelector('[data-form-status]');
    const quantityInput = root.querySelector('[data-quantity-input]');
    const quantityMinus = root.querySelector('[data-quantity-minus]');
    const quantityPlus = root.querySelector('[data-quantity-plus]');
    const uploadEmpty = root.dataset.uploadEmpty;
    const uploadButton = root.dataset.uploadButton;
    const uploadReplace = root.dataset.uploadReplace;
    const previewPdf = root.dataset.previewPdf;
    const fileError = root.dataset.fileError;
    const formError = root.dataset.formError;
    const formErrorSecond = root.dataset.formErrorSecond;
    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    const mugPhoto = new Image();
    const viewPresets = [0.75, 0.5, 0.25];
    const state = {
      mode: 'single',
      view: 0.75,
      dragging: false,
      interaction: 'view',
      pointerId: null,
      lastX: 0,
      lastY: 0,
      startTransform: null,
      startDistance: 0,
      activePlacement: null,
      mugReady: false,
      mugError: false,
      color: '#101820',
      font: 'Arial, sans-serif',
      textSize: 32,
      assets: { primary: null, secondary: null },
      transforms: {
        primary: { x: 0.5, y: 0.5, scale: 0.7 },
        secondary: { x: 0.5, y: 0.5, scale: 0.7 }
      },
      frame: 0
    };

    const nearestView = (view) => viewPresets.reduce((nearest, preset) => (
      Math.abs(preset - view) < Math.abs(nearest - view) ? preset : nearest
    ), viewPresets[0]);

    const requestRender = () => {
      if (state.frame) return;
      state.frame = window.requestAnimationFrame(() => {
        state.frame = 0;
        render();
      });
    };

    const roundedRect = (drawingContext, x, y, width, height, radius) => {
      const safeRadius = Math.min(radius, width / 2, height / 2);
      drawingContext.beginPath();
      drawingContext.moveTo(x + safeRadius, y);
      drawingContext.lineTo(x + width - safeRadius, y);
      drawingContext.quadraticCurveTo(x + width, y, x + width, y + safeRadius);
      drawingContext.lineTo(x + width, y + height - safeRadius);
      drawingContext.quadraticCurveTo(x + width, y + height, x + width - safeRadius, y + height);
      drawingContext.lineTo(x + safeRadius, y + height);
      drawingContext.quadraticCurveTo(x, y + height, x, y + height - safeRadius);
      drawingContext.lineTo(x, y + safeRadius);
      drawingContext.quadraticCurveTo(x, y, x + safeRadius, y);
      drawingContext.closePath();
    };

    const drawContainedImage = (drawingContext, image, x, y, width, height) => {
      const scale = Math.min(width / image.naturalWidth, height / image.naturalHeight);
      const renderedWidth = image.naturalWidth * scale;
      const renderedHeight = image.naturalHeight * scale;
      drawingContext.drawImage(
        image,
        x + (width - renderedWidth) / 2,
        y + (height - renderedHeight) / 2,
        renderedWidth,
        renderedHeight
      );
    };

    const drawContainedCrop = (drawingContext, image, x, y, width, height, crop) => {
      if (!crop) {
        drawContainedImage(drawingContext, image, x, y, width, height);
        return;
      }
      const sourceX = image.naturalWidth * crop.start;
      const sourceWidth = image.naturalWidth * crop.width;
      const scale = Math.min(width / sourceWidth, height / image.naturalHeight);
      const renderedWidth = sourceWidth * scale;
      const renderedHeight = image.naturalHeight * scale;
      drawingContext.drawImage(
        image,
        sourceX,
        0,
        sourceWidth,
        image.naturalHeight,
        x + (width - renderedWidth) / 2,
        y + (height - renderedHeight) / 2,
        renderedWidth,
        renderedHeight
      );
    };

    const drawOriginalMug = (drawingContext, width, height, view) => {
      drawingContext.save();
      drawingContext.fillStyle = '#f4f4f4';
      drawingContext.fillRect(0, 0, width, height);
      if (!state.mugReady) {
        drawingContext.restore();
        return;
      }

      drawingContext.imageSmoothingEnabled = true;
      drawingContext.imageSmoothingQuality = 'high';
      const sourceWidth = mugPhoto.naturalWidth;
      const sourceHeight = mugPhoto.naturalHeight;
      const selectedView = nearestView(view);

      if (selectedView === 0.5) {
        const destinationX = width * 0.24;
        const destinationY = height * 0.08;
        const destinationWidth = width * 0.52;
        const destinationHeight = height * 0.84;
        const sourceX = sourceWidth * 0.215;
        const sourceY = sourceHeight * 0.145;
        const sourceHalfWidth = sourceWidth * 0.20;
        const sourceBodyHeight = sourceHeight * 0.51;
        drawingContext.save();
        roundedRect(
          drawingContext,
          destinationX,
          destinationY,
          destinationWidth,
          destinationHeight,
          Math.max(5, destinationWidth * 0.035)
        );
        drawingContext.clip();
        drawingContext.drawImage(
          mugPhoto,
          sourceX,
          sourceY,
          sourceHalfWidth,
          sourceBodyHeight,
          destinationX,
          destinationY,
          destinationWidth / 2,
          destinationHeight
        );
        drawingContext.translate(destinationX + destinationWidth, 0);
        drawingContext.scale(-1, 1);
        drawingContext.drawImage(
          mugPhoto,
          sourceX,
          sourceY,
          sourceHalfWidth,
          sourceBodyHeight,
          0,
          destinationY,
          destinationWidth / 2,
          destinationHeight
        );
        drawingContext.restore();
      } else {
        if (selectedView === 0.25) {
          drawingContext.translate(width, 0);
          drawingContext.scale(-1, 1);
        }
        drawingContext.drawImage(
          mugPhoto,
          sourceWidth * 0.10,
          sourceHeight * 0.075,
          sourceWidth * 0.79,
          sourceHeight * 0.64,
          0,
          0,
          width,
          height
        );
      }
      drawingContext.restore();
    };

    const printRectangle = (width, height, view) => {
      const selectedView = nearestView(view);
      const printHeight = height * 0.78;
      const printWidth = printHeight * 80 / 95;
      const rightCenter = width * 0.40;
      const frontCenter = width * 0.50;
      const leftCenter = width * 0.60;
      if (selectedView === 0.75) return { x: rightCenter - printWidth / 2, y: height * 0.11, width: printWidth, height: printHeight };
      if (selectedView === 0.25) return { x: leftCenter - printWidth / 2, y: height * 0.11, width: printWidth, height: printHeight };
      return { x: frontCenter - printWidth / 2, y: height * 0.11, width: printWidth, height: printHeight };
    };

    const artworkForView = (view) => {
      const selectedView = nearestView(view);
      if (state.mode === 'wrap') {
        const cropStart = selectedView === 0.75 ? 0 : selectedView === 0.5 ? 1 / 3 : 2 / 3;
        return {
          active: true,
          asset: state.assets.primary,
          assetKey: 'primary',
          crop: { start: cropStart, width: 1 / 3 },
          label: root.dataset.canvasWrap,
          showText: selectedView === 0.5
        };
      }
      if (state.mode === 'double') {
        if (selectedView === 0.75) return { active: true, asset: state.assets.primary, assetKey: 'primary', crop: null, label: `${root.dataset.canvasPrint} A`, showText: true };
        if (selectedView === 0.25) {
          const usePrimary = repeatArtwork.checked;
          return {
            active: true,
            asset: usePrimary ? state.assets.primary : state.assets.secondary,
            assetKey: usePrimary ? 'primary' : 'secondary',
            crop: null,
            label: `${root.dataset.canvasPrint} B`,
            showText: true
          };
        }
        return { active: false, asset: null, assetKey: 'primary', crop: null, label: '', showText: false };
      }
      const selectedPosition = Number.parseFloat(positionSelect.selectedOptions[0].dataset.view);
      return {
        active: Math.abs(selectedView - selectedPosition) < 0.01,
        asset: state.assets.primary,
        assetKey: 'primary',
        crop: null,
        label: root.dataset.canvasPrint,
        showText: true
      };
    };

    const clamp = (value, minimum, maximum) => Math.min(maximum, Math.max(minimum, value));

    const imagePlacement = (rectangle, asset, crop, transform) => {
      if (!asset || !asset.image) return null;
      const sourceWidth = asset.image.naturalWidth * (crop ? crop.width : 1);
      const sourceHeight = asset.image.naturalHeight;
      const containedScale = Math.min(rectangle.width / sourceWidth, rectangle.height / sourceHeight);
      const safeScale = clamp(transform.scale, 0.15, 1);
      const width = sourceWidth * containedScale * safeScale;
      const height = sourceHeight * containedScale * safeScale;
      const halfX = width / rectangle.width / 2;
      const halfY = height / rectangle.height / 2;
      transform.scale = safeScale;
      transform.x = clamp(transform.x, halfX, 1 - halfX);
      transform.y = clamp(transform.y, halfY, 1 - halfY);
      return {
        x: rectangle.x + rectangle.width * transform.x - width / 2,
        y: rectangle.y + rectangle.height * transform.y - height / 2,
        width,
        height
      };
    };

    const drawSelectionTag = (drawingContext, text, x, y) => {
      drawingContext.font = `700 ${Math.max(13, canvas.width * 0.022)}px sans-serif`;
      const paddingX = Math.max(7, canvas.width * 0.012);
      const height = Math.max(25, canvas.height * 0.055);
      const width = drawingContext.measureText(text).width + paddingX * 2;
      drawingContext.fillStyle = '#05080c';
      drawingContext.fillRect(x - width / 2, y - height / 2, width, height);
      drawingContext.fillStyle = '#ffffff';
      drawingContext.textAlign = 'center';
      drawingContext.textBaseline = 'middle';
      drawingContext.fillText(text, x, y);
    };

    const drawArtworkPreview = (drawingContext, rectangle, asset, assetKey, crop, label, textValue) => {
      const transform = state.transforms[assetKey] || state.transforms.primary;
      const placement = imagePlacement(rectangle, asset, crop, transform);
      drawingContext.save();
      roundedRect(drawingContext, rectangle.x, rectangle.y, rectangle.width, rectangle.height, Math.max(8, rectangle.width * 0.045));
      if (!asset && !textValue) {
        drawingContext.fillStyle = 'rgba(0, 200, 243, .045)';
        drawingContext.fill();
      }
      drawingContext.clip();

      if (placement && asset && asset.image) {
        const sourceX = crop ? asset.image.naturalWidth * crop.start : 0;
        const sourceWidth = crop ? asset.image.naturalWidth * crop.width : asset.image.naturalWidth;
        drawingContext.drawImage(
          asset.image,
          sourceX,
          0,
          sourceWidth,
          asset.image.naturalHeight,
          placement.x,
          placement.y,
          placement.width,
          placement.height
        );
      } else if (asset && asset.pdf) {
        drawingContext.fillStyle = 'rgba(5, 20, 29, .74)';
        drawingContext.font = `700 ${Math.max(15, rectangle.width * 0.085)}px sans-serif`;
        drawingContext.textAlign = 'center';
        drawingContext.textBaseline = 'middle';
        drawingContext.fillText(previewPdf, rectangle.x + rectangle.width / 2, rectangle.y + rectangle.height / 2);
      } else if (!textValue) {
        drawingContext.fillStyle = 'rgba(5, 20, 29, .54)';
        drawingContext.font = `700 ${Math.max(13, rectangle.width * 0.065)}px sans-serif`;
        drawingContext.textAlign = 'center';
        drawingContext.textBaseline = 'middle';
        drawingContext.fillText(label, rectangle.x + rectangle.width / 2, rectangle.y + rectangle.height / 2, rectangle.width * 0.82);
      }

      if (textValue) {
        const fontSize = Math.max(14, rectangle.width * state.textSize / 220);
        drawingContext.font = `800 ${fontSize}px ${state.font}`;
        drawingContext.textAlign = 'center';
        drawingContext.textBaseline = 'middle';
        drawingContext.lineWidth = Math.max(2, fontSize * 0.10);
        drawingContext.strokeStyle = 'rgba(255, 255, 255, .9)';
        drawingContext.fillStyle = state.color;
        drawingContext.strokeText(textValue, rectangle.x + rectangle.width / 2, rectangle.y + rectangle.height * 0.84, rectangle.width * 0.86);
        drawingContext.fillText(textValue, rectangle.x + rectangle.width / 2, rectangle.y + rectangle.height * 0.84, rectangle.width * 0.86);
      }

      const curveShade = drawingContext.createLinearGradient(rectangle.x, 0, rectangle.x + rectangle.width, 0);
      curveShade.addColorStop(0, 'rgba(6, 18, 26, .18)');
      curveShade.addColorStop(0.2, 'rgba(255, 255, 255, .01)');
      curveShade.addColorStop(0.72, 'rgba(255, 255, 255, .06)');
      curveShade.addColorStop(1, 'rgba(6, 18, 26, .18)');
      drawingContext.fillStyle = curveShade;
      drawingContext.fillRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
      drawingContext.restore();

      drawingContext.save();
      roundedRect(drawingContext, rectangle.x, rectangle.y, rectangle.width, rectangle.height, Math.max(8, rectangle.width * 0.045));
      drawingContext.setLineDash([Math.max(5, rectangle.width * 0.02), Math.max(4, rectangle.width * 0.015)]);
      drawingContext.strokeStyle = 'rgba(0, 200, 243, .62)';
      drawingContext.lineWidth = Math.max(1.5, rectangle.width * 0.006);
      drawingContext.stroke();
      drawingContext.restore();

      if (placement) {
        drawingContext.save();
        drawingContext.strokeStyle = '#2f63ff';
        drawingContext.lineWidth = Math.max(2, canvas.width * 0.004);
        drawingContext.setLineDash([]);
        drawingContext.strokeRect(placement.x, placement.y, placement.width, placement.height);
        const handleRadius = Math.max(8, canvas.width * 0.015);
        drawingContext.beginPath();
        drawingContext.arc(placement.x + placement.width, placement.y + placement.height, handleRadius, 0, Math.PI * 2);
        drawingContext.fillStyle = '#2f63ff';
        drawingContext.fill();
        drawingContext.lineWidth = Math.max(2, handleRadius * 0.22);
        drawingContext.strokeStyle = '#ffffff';
        drawingContext.stroke();
        const widthCm = placement.width / rectangle.width * 8;
        const heightCm = placement.height / rectangle.height * 9.5;
        drawSelectionTag(drawingContext, `${widthCm.toFixed(1)} cm`, placement.x + placement.width / 2, Math.max(16, placement.y - canvas.height * 0.035));
        drawingContext.save();
        drawingContext.translate(Math.max(18, placement.x - canvas.width * 0.032), placement.y + placement.height / 2);
        drawingContext.rotate(-Math.PI / 2);
        drawSelectionTag(drawingContext, `${heightCm.toFixed(1)} cm`, 0, 0);
        drawingContext.restore();
        drawingContext.restore();
      }
      return placement;
    };

    const renderThumbnails = () => {
      root.querySelectorAll('[data-view-thumbnail]').forEach((thumbnail) => {
        const thumbnailContext = thumbnail.getContext('2d');
        drawOriginalMug(
          thumbnailContext,
          thumbnail.width,
          thumbnail.height,
          Number.parseFloat(thumbnail.dataset.viewThumbnail)
        );
      });
    };

    const render = () => {
      const width = canvas.width;
      const height = canvas.height;
      if (!width || !height) return;
      context.clearRect(0, 0, width, height);
      const selectedView = nearestView(state.view);
      drawOriginalMug(context, width, height, selectedView);
      const preview = artworkForView(selectedView);
      const rectangle = printRectangle(width, height, selectedView);
      state.activePlacement = null;
      if (preview.active) {
        state.activePlacement = drawArtworkPreview(
          context,
          rectangle,
          preview.asset,
          preview.assetKey,
          preview.crop,
          preview.label,
          preview.showText ? textInput.value.trim() : ''
        );
      }

      const editable = Boolean(preview.active && preview.asset && preview.asset.image && state.activePlacement);
      editorTools.hidden = !editable;
      if (editable) {
        const widthCm = state.activePlacement.width / rectangle.width * 8;
        const heightCm = state.activePlacement.height / rectangle.height * 9.5;
        const sizeValue = `${widthCm.toFixed(1)} × ${heightCm.toFixed(1)} cm`;
        artSizeOutput.textContent = sizeValue;
        layoutSizeInput.value = sizeValue;
        layoutSizeInput.setAttribute('value', sizeValue);
        const transform = state.transforms[preview.assetKey];
        const positionValue = `X ${Math.round(transform.x * 100)} % · Y ${Math.round(transform.y * 100)} %`;
        layoutPositionInput.value = positionValue;
        layoutPositionInput.setAttribute('value', positionValue);
      } else {
        artSizeOutput.textContent = '';
        layoutSizeInput.value = '';
        layoutSizeInput.removeAttribute('value');
        layoutPositionInput.value = '';
        layoutPositionInput.removeAttribute('value');
      }

      const activeButton = root.querySelector(`[data-view-preset="${selectedView}"]`);
      const viewLabel = activeButton ? activeButton.dataset.viewLabel : '';
      viewStatus.textContent = root.dataset.viewTemplate.replace('[view]', viewLabel);
      root.querySelectorAll('[data-view-preset]').forEach((button) => {
        const active = Math.abs(Number.parseFloat(button.dataset.viewPreset) - selectedView) < 0.01;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };

    mugPhoto.addEventListener('load', () => {
      state.mugReady = true;
      state.mugError = false;
      renderThumbnails();
      requestRender();
    }, { once: true });
    mugPhoto.addEventListener('error', () => {
      state.mugError = true;
      requestRender();
    }, { once: true });
    mugPhoto.src = root.dataset.mugPhoto;

    const resizeCanvas = () => {
      const bounds = canvas.getBoundingClientRect();
      const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
      const nextWidth = Math.max(1, Math.round(bounds.width * pixelRatio));
      const nextHeight = Math.max(1, Math.round(bounds.height * pixelRatio));
      if (canvas.width !== nextWidth || canvas.height !== nextHeight) {
        canvas.width = nextWidth;
        canvas.height = nextHeight;
      }
      requestRender();
    };

    const clearAsset = (key) => {
      const asset = state.assets[key];
      if (asset && asset.url) URL.revokeObjectURL(asset.url);
      state.assets[key] = null;
      state.transforms[key] = { x: 0.5, y: 0.5, scale: 0.7 };
      fileNames[key].textContent = uploadEmpty;
      uploadActions[key].textContent = uploadButton;
      qualityChecks[key].textContent = '';
      qualityChecks[key].className = 'ks-mug__quality-check';
      requestRender();
    };

    const updateQuality = (key) => {
      const asset = state.assets[key];
      const quality = qualityChecks[key];
      if (!asset) {
        quality.textContent = '';
        quality.className = 'ks-mug__quality-check';
        return;
      }
      quality.className = 'ks-mug__quality-check is-visible';
      if (asset.pdf) {
        quality.textContent = root.dataset.qualityPdf;
        quality.classList.add('is-good');
        return;
      }
      const requirement = state.mode === 'wrap' ? { width: 2835, height: 1122 } : { width: 945, height: 1122 };
      const suitable = asset.width >= requirement.width && asset.height >= requirement.height;
      quality.textContent = `${asset.width} × ${asset.height} px · ${suitable ? root.dataset.qualityGood : root.dataset.qualityLow}`;
      quality.classList.add(suitable ? 'is-good' : 'is-warning');
    };

    const showFile = (key, file) => {
      if (!file) {
        clearAsset(key);
        return;
      }
      const extension = file.name.split('.').pop().toLowerCase();
      const validByExtension = ['jpg', 'jpeg', 'png', 'pdf'].includes(extension);
      if (!allowedTypes.includes(file.type) && !validByExtension) {
        fileInputs[key].value = '';
        status.textContent = fileError;
        clearAsset(key);
        return;
      }
      status.textContent = '';
      fileNames[key].textContent = file.name;
      uploadActions[key].textContent = uploadReplace;
      if (file.type === 'application/pdf' || extension === 'pdf') {
        const oldAsset = state.assets[key];
        if (oldAsset && oldAsset.url) URL.revokeObjectURL(oldAsset.url);
        state.assets[key] = { pdf: true, image: null, width: 0, height: 0, url: '' };
        updateQuality(key);
        requestRender();
        return;
      }
      const image = new Image();
      const objectUrl = URL.createObjectURL(file);
      image.addEventListener('load', () => {
        const oldAsset = state.assets[key];
        if (oldAsset && oldAsset.url) URL.revokeObjectURL(oldAsset.url);
        state.assets[key] = {
          pdf: false,
          image,
          width: image.naturalWidth,
          height: image.naturalHeight,
          url: objectUrl
        };
        state.transforms[key] = { x: 0.5, y: 0.5, scale: 0.7 };
        updateQuality(key);
        requestRender();
      }, { once: true });
      image.addEventListener('error', () => {
        URL.revokeObjectURL(objectUrl);
        fileInputs[key].value = '';
        status.textContent = fileError;
        clearAsset(key);
      }, { once: true });
      image.src = objectUrl;
    };

    Object.entries(fileInputs).forEach(([key, input]) => {
      input.addEventListener('change', () => showFile(key, input.files[0]));
      const dropzone = root.querySelector(`[data-dropzone="${key}"]`);
      ['dragenter', 'dragover'].forEach((eventName) => {
        dropzone.addEventListener(eventName, (event) => {
          event.preventDefault();
          dropzone.classList.add('is-dragging');
        });
      });
      ['dragleave', 'drop'].forEach((eventName) => {
        dropzone.addEventListener(eventName, (event) => {
          event.preventDefault();
          dropzone.classList.remove('is-dragging');
        });
      });
      dropzone.addEventListener('drop', (event) => {
        const droppedFile = event.dataTransfer.files[0];
        if (!droppedFile) return;
        const transfer = new DataTransfer();
        transfer.items.add(droppedFile);
        input.files = transfer.files;
        showFile(key, droppedFile);
      });
    });

    const updateSecondaryUpload = () => {
      const showSecondFile = state.mode === 'double' && !repeatArtwork.checked;
      secondaryDropzone.hidden = !showSecondFile;
      fileInputs.secondary.disabled = !showSecondFile;
      requestRender();
    };

    const applyMode = (mode) => {
      state.mode = mode;
      stage.dataset.mode = mode;
      const copy = root.querySelector(`[data-mode-copy="${mode}"]`);
      modeTitle.textContent = copy.dataset.title;
      modeDetail.textContent = copy.dataset.detail;
      modePixels.textContent = copy.dataset.pixels;
      secondaryUpload.hidden = mode !== 'double';
      repeatArtwork.disabled = mode !== 'double';
      positionField.hidden = mode !== 'single';
      positionSelect.disabled = mode !== 'single';
      wrapNote.hidden = mode !== 'wrap';
      uploadGuidance.textContent = root.dataset[`uploadText${mode.charAt(0).toUpperCase()}${mode.slice(1)}`];
      if (mode === 'single') state.view = Number.parseFloat(positionSelect.selectedOptions[0].dataset.view);
      if (mode === 'double') state.view = 0.75;
      if (mode === 'wrap') state.view = 0.5;
      updateSecondaryUpload();
      updateQuality('primary');
      updateQuality('secondary');
      status.textContent = '';
      requestRender();
    };

    root.querySelectorAll('[data-print-mode]').forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked) applyMode(input.dataset.printMode);
      });
    });

    repeatArtwork.addEventListener('change', () => {
      updateSecondaryUpload();
      status.textContent = '';
    });

    textInput.addEventListener('input', () => {
      status.textContent = '';
      requestRender();
    });

    fontSelect.addEventListener('change', () => {
      state.font = fontSelect.selectedOptions[0].dataset.font;
      requestRender();
    });

    textSizeInput.addEventListener('input', () => {
      state.textSize = Number.parseInt(textSizeInput.value, 10);
      textSizeOutput.textContent = textSizeInput.value;
      requestRender();
    });

    root.querySelectorAll('[data-text-color]').forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked) {
          state.color = input.dataset.textColor;
          requestRender();
        }
      });
    });

    positionSelect.addEventListener('change', () => {
      state.view = Number.parseFloat(positionSelect.selectedOptions[0].dataset.view);
      status.textContent = '';
      requestRender();
    });

    const setView = (view, syncSinglePosition = true) => {
      state.view = nearestView(view);
      if (syncSinglePosition && state.mode === 'single') {
        const matchingOption = Array.from(positionSelect.options).find((option) => (
          Math.abs(Number.parseFloat(option.dataset.view) - state.view) < 0.01
        ));
        if (matchingOption) positionSelect.value = matchingOption.value;
      }
      status.textContent = '';
      requestRender();
    };

    const moveView = (direction) => {
      const currentIndex = viewPresets.indexOf(nearestView(state.view));
      const nextIndex = Math.min(viewPresets.length - 1, Math.max(0, currentIndex + direction));
      setView(viewPresets[nextIndex]);
    };

    root.querySelectorAll('[data-view-preset]').forEach((button) => {
      button.addEventListener('click', () => {
        setView(Number.parseFloat(button.dataset.viewPreset));
      });
    });

    const activeArtwork = () => artworkForView(nearestView(state.view));

    const adjustArtworkScale = (delta) => {
      const preview = activeArtwork();
      if (!preview.active || !preview.asset || !preview.asset.image) return;
      const transform = state.transforms[preview.assetKey];
      transform.scale = clamp(transform.scale + delta, 0.15, 1);
      requestRender();
    };

    root.querySelectorAll('[data-art-zoom]').forEach((button) => {
      button.addEventListener('click', () => adjustArtworkScale(Number.parseFloat(button.dataset.artZoom)));
    });

    root.querySelector('[data-art-center]').addEventListener('click', () => {
      const preview = activeArtwork();
      if (!preview.active) return;
      state.transforms[preview.assetKey].x = 0.5;
      state.transforms[preview.assetKey].y = 0.5;
      requestRender();
    });

    canvas.addEventListener('pointerdown', (event) => {
      state.dragging = true;
      state.pointerId = event.pointerId;
      state.lastX = event.clientX;
      state.lastY = event.clientY;
      state.interaction = 'view';
      const bounds = canvas.getBoundingClientRect();
      const point = {
        x: (event.clientX - bounds.left) * canvas.width / bounds.width,
        y: (event.clientY - bounds.top) * canvas.height / bounds.height
      };
      const preview = activeArtwork();
      const placement = state.activePlacement;
      if (preview.active && preview.asset && preview.asset.image && placement) {
        const handleX = placement.x + placement.width;
        const handleY = placement.y + placement.height;
        const handleHit = Math.hypot(point.x - handleX, point.y - handleY) <= Math.max(22, canvas.width * 0.04);
        const inside = point.x >= placement.x && point.x <= placement.x + placement.width && point.y >= placement.y && point.y <= placement.y + placement.height;
        if (handleHit) state.interaction = 'resize';
        else if (inside) state.interaction = 'move';
        if (state.interaction !== 'view') {
          const transform = state.transforms[preview.assetKey];
          state.startTransform = { x: transform.x, y: transform.y, scale: transform.scale };
          state.startDistance = Math.max(1, Math.hypot(point.x - (placement.x + placement.width / 2), point.y - (placement.y + placement.height / 2)));
          canvas.style.cursor = state.interaction === 'resize' ? 'nwse-resize' : 'move';
        }
      }
      canvas.setPointerCapture(event.pointerId);
    });

    canvas.addEventListener('pointermove', (event) => {
      if (!state.dragging || event.pointerId !== state.pointerId) return;
      const preview = activeArtwork();
      if (state.interaction === 'move' && preview.active) {
        event.preventDefault();
        const bounds = canvas.getBoundingClientRect();
        const rectangle = printRectangle(canvas.width, canvas.height, state.view);
        const transform = state.transforms[preview.assetKey];
        transform.x += (event.clientX - state.lastX) * canvas.width / bounds.width / rectangle.width;
        transform.y += (event.clientY - state.lastY) * canvas.height / bounds.height / rectangle.height;
        imagePlacement(rectangle, preview.asset, preview.crop, transform);
        state.lastX = event.clientX;
        state.lastY = event.clientY;
        requestRender();
        return;
      }
      if (state.interaction === 'resize' && preview.active && state.activePlacement) {
        event.preventDefault();
        const bounds = canvas.getBoundingClientRect();
        const point = {
          x: (event.clientX - bounds.left) * canvas.width / bounds.width,
          y: (event.clientY - bounds.top) * canvas.height / bounds.height
        };
        const placement = state.activePlacement;
        const distance = Math.hypot(point.x - (placement.x + placement.width / 2), point.y - (placement.y + placement.height / 2));
        state.transforms[preview.assetKey].scale = clamp(state.startTransform.scale * distance / state.startDistance, 0.15, 1);
        requestRender();
        return;
      }
      const deltaX = event.clientX - state.lastX;
      if (Math.abs(deltaX) < 42) return;
      moveView(deltaX < 0 ? 1 : -1);
      state.lastX = event.clientX;
    });

    const finishDrag = (event) => {
      if (event.pointerId !== state.pointerId) return;
      state.dragging = false;
      state.interaction = 'view';
      state.pointerId = null;
      state.startTransform = null;
      canvas.style.cursor = '';
      if (canvas.hasPointerCapture(event.pointerId)) canvas.releasePointerCapture(event.pointerId);
    };

    canvas.addEventListener('pointerup', finishDrag);
    canvas.addEventListener('pointercancel', finishDrag);

    canvas.addEventListener('keydown', (event) => {
      if (!['ArrowLeft', 'ArrowRight', 'Home'].includes(event.key)) return;
      event.preventDefault();
      if (event.key === 'ArrowLeft') moveView(-1);
      if (event.key === 'ArrowRight') moveView(1);
      if (event.key === 'Home') {
        setView(state.mode === 'single' ? Number.parseFloat(positionSelect.selectedOptions[0].dataset.view) : 0.5);
      }
    });

    quantityMinus.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number.parseInt(quantityInput.value || '1', 10) - 1);
    });

    quantityPlus.addEventListener('click', () => {
      quantityInput.value = Math.max(1, Number.parseInt(quantityInput.value || '1', 10) + 1);
    });

    resetButton.addEventListener('click', () => {
      fileInputs.primary.value = '';
      fileInputs.secondary.value = '';
      clearAsset('primary');
      clearAsset('secondary');
      textInput.value = '';
      fontSelect.selectedIndex = 0;
      textSizeInput.value = '32';
      textSizeOutput.textContent = '32';
      positionSelect.selectedIndex = 0;
      repeatArtwork.checked = true;
      root.querySelector('[data-print-mode="single"]').checked = true;
      root.querySelector('[data-text-color="#101820"]').checked = true;
      state.color = '#101820';
      state.font = fontSelect.selectedOptions[0].dataset.font;
      state.textSize = 32;
      applyMode('single');
      status.textContent = '';
    });

    form.addEventListener('submit', (event) => {
      if (!fileInputs.primary.files.length && !textInput.value.trim()) {
        event.preventDefault();
        status.textContent = formError;
        fileInputs.primary.focus();
        return;
      }
      if (state.mode === 'double' && !repeatArtwork.checked && !fileInputs.secondary.files.length) {
        event.preventDefault();
        status.textContent = formErrorSecond;
        fileInputs.secondary.focus();
      }
    });

    const resizeObserver = new ResizeObserver(resizeCanvas);
    resizeObserver.observe(canvas);
    applyMode('single');
    resizeCanvas();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reference-2-WDR"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializePressCarousels = (scope = document) => {
      scope.querySelectorAll('[data-press-carousel]').forEach((carousel) => {
        if (carousel.dataset.initialized === 'true') return;

        const track = carousel.querySelector('.ks-press-grid');
        const previousButton = carousel.querySelector('[data-press-previous]');
        const nextButton = carousel.querySelector('[data-press-next]');

        if (!track || !previousButton || !nextButton) return;

        carousel.dataset.initialized = 'true';
        let animationFrame;
        let settleTimer;

        const updateButtons = () => {
          const maximumScroll = Math.max(0, track.scrollWidth - track.clientWidth);
          const hasOverflow = maximumScroll > 8;

          carousel.classList.toggle('is-overflowing', hasOverflow);
          previousButton.disabled = !hasOverflow || track.scrollLeft <= 4;
          nextButton.disabled = !hasOverflow || track.scrollLeft >= maximumScroll - 4;
        };

        const scrollCards = (direction) => {
          const cards = Array.from(track.querySelectorAll('.ks-press-card'));
          if (cards.length === 0) return;

          const positions = cards.map((card) => card.offsetLeft - track.offsetLeft);
          const currentPosition = track.scrollLeft;
          const closestIndex = positions.reduce((nearestIndex, position, index) => {
            const nearestDistance = Math.abs(positions[nearestIndex] - currentPosition);
            return Math.abs(position - currentPosition) < nearestDistance ? index : nearestIndex;
          }, 0);
          const targetIndex = Math.min(cards.length - 1, Math.max(0, closestIndex + direction));
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          track.scrollTo({
            left: positions[targetIndex],
            behavior: reducedMotion ? 'auto' : 'smooth'
          });

          window.clearTimeout(settleTimer);
          settleTimer = window.setTimeout(updateButtons, reducedMotion ? 0 : 600);
        };

        previousButton.addEventListener('click', () => scrollCards(-1));
        nextButton.addEventListener('click', () => scrollCards(1));
        track.addEventListener('scroll', () => {
          window.cancelAnimationFrame(animationFrame);
          animationFrame = window.requestAnimationFrame(updateButtons);
        }, { passive: true });
        track.addEventListener('scrollend', updateButtons, { passive: true });

        const resizeObserver = new ResizeObserver(updateButtons);
        resizeObserver.observe(track);
        carousel.pressResizeObserver = resizeObserver;
        updateButtons();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializePressCarousels());
    } else {
      initializePressCarousels();
    }

    document.addEventListener('shopify:section:load', (event) => initializePressCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const button = event.target.closest('.shopify-section--video .video-play-button');
    if (!button) return;
    const player = button.closest('.shopify-section--video').querySelector('video-media');
    if (!player || typeof player.play !== 'function') return;
    player.play();
    if (event.detail === 0) {
      requestAnimationFrame(() => player.querySelector('video, iframe')?.focus());
    }
  });

  } catch(e) { console.error(e); }
})();
})();
